import PropTypes from 'prop-types';

export const restaurantPropTypes = PropTypes.shape({
  objectId: PropTypes.string,
  enabled: PropTypes.bool,
  name: PropTypes.string,
  region: PropTypes.string,
  hours: PropTypes.string,
  hoursParsed: PropTypes.shape({}),
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postcode: PropTypes.string,
  phone: PropTypes.string,
  website: PropTypes.string,
  abn: PropTypes.string,
  tradingName: PropTypes.string,
  instagramLink: PropTypes.string,
  facebookLink: PropTypes.string,
  twitterLink: PropTypes.string,
  premium: PropTypes.bool,
  obeeGoLiveDate: PropTypes.string,
  obeeToken: PropTypes.string,
  obeeIsLive: PropTypes.bool,
  closedEarly: PropTypes.bool,
  slug: PropTypes.string,
  linkedVenues: PropTypes.arrayOf(PropTypes.shape({})),
});

export const restaurantActivePropTypes = PropTypes.shape({
  restaurant: restaurantPropTypes,
  id: PropTypes.string,
  restaurantFetching: PropTypes.bool,
  fetching: PropTypes.bool,
});

export const RestaurantInputKeys = () => [
  'name',
  'address1',
  'address2',
  'city',
  'state',
  'postcode',
  'phone',
  'website',
  'abn',
  'tradingName',
  'instagramLink',
  'facebookLink',
  'twitterLink',
];
